( function () {
	'use strict';

	// @ngInject
	function persistence () {
		var observationsActiveList = 0;
		var templatesActiveList    = 0;
		var scheduleActiveList     = 0;
		var reportsActiveList      = 0;

		var service = {
			'observationsActiveList' : observationsActiveList,
			'templatesActiveList'    : templatesActiveList,
			'scheduleActiveList'     : scheduleActiveList,
			'reportsActiveList'      : reportsActiveList
		};

		return service;
	}

	angular
	.module( 'app.core' )
	.factory( 'persistence', persistence );
} )( );
